<template>
  <div class="flex flex-row justify-center">
    <div class="w-full max-w-lg">
      <div class="sm:hidden">
        <label for="tabs" class="sr-only">Select a tab</label>
        <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
        <select
          id="tabs"
          name="tabs"
          class="block w-full focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
        >
          <option
            v-for="tab in option_tabs"
            :key="tab.name"
            :selected="tab.current"
          >
            {{ tab.name }}
          </option>
        </select>
      </div>
      <div class="hidden sm:block">
        <nav
          class="relative z-0 rounded-lg shadow flex divide-x divide-gray-200"
          aria-label="Tabs"
        >
          <a
            v-for="(tab, tabIdx) in option_tabs"
            :key="tab.name"
            href="#"
            @click.prevent="switchTab(tabIdx)"
            :class="[
              tab.current
                ? 'text-gray-900'
                : 'text-gray-500 hover:text-gray-700',
              tabIdx === 0 ? 'rounded-l-lg' : '',
              tabIdx === option_tabs.length - 1 ? 'rounded-r-lg' : '',
              'group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10',
            ]"
            :aria-current="tab.current ? 'page' : undefined"
          >
            <i :class="tab.icon"></i>
            <span class="space-icon"></span>
            <span>{{ tab.name }}</span>
            <span
              aria-hidden="true"
              :class="[
                tab.current ? 'bg-indigo-500' : 'bg-transparent',
                'absolute inset-x-0 bottom-0 h-0.5',
              ]"
            />
          </a>
        </nav>
      </div>
    </div>
  </div>

  <div class="mt-6" v-show="this.option_tabs[0].current">
    <div class="sm:flex sm:items-center">
      <div class="sm:flex-auto">
        <h1 class="text-xl font-semibold text-gray-900">Contenedores</h1>
      </div>
    </div>
    <!-- <div class="flex flex-row justify-end">
      <button
        type="button"
        @click.prevent="download_rep_xlsx"
        class="btn-white"
      >
        <i class="fa-solid fa-file-excel"></i
        ><span class="space-icon"></span>Generar reporte de producción
      </button>
    </div> -->
    <div class="mt-8 flex flex-col">
      <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <div
            class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"
          >
            <div
              class="w-full lg:flex p-3"
              v-for="container in containers"
              :key="container.id"
            >
              <div
                class="w-full border-gray-400 bg-white p-4 flex flex-col justify-between rounded-lg"
              >
                <div>
                  <div class="flex justify-between">
                    <div class="text-gray-900 font-bold text-xl mb-2">
                      {{ container.container_code }}
                    </div>
                    <div class="flex">
                      <div class="text-gray-900 text-md mb-2">
                        {{ container.total_package_groups }} pallets
                      </div>
                    </div>
                    <div class="flex">
                      <div class="text-gray-900 text-md mb-2">
                        {{ container.total_exp_packages }} Kg
                      </div>
                    </div>
                  </div>
                  <div class="md:flex justify-between">
                    <div class="text-gray-700 font-bold text-md">
                      {{ container.agro_exporter.name }}
                    </div>
                    <div class="flex text-right">
                      <div class="flex text-gray-900 text-md mb-2">
                        <img
                          src="https://cdn.countryflags.com/thumbs/peru/flag-400.png"
                          alt="peru flag"
                          class="max-h-4 px-1 mt-1"
                        />
                        <p>Paita</p>
                      </div>
                      <div class="px-2">
                        <i class="fa-solid fa-arrow-right-long"></i>
                      </div>
                      <div class="flex text-gray-900 text-md mb-2">
                        <img
                          src="https://www.countryflags.com/wp-content/uploads/netherlands-flag-png-large.png"
                          alt="netherlands flag"
                          class="max-h-4 px-1 mt-1"
                        />
                        <p>Holanda</p>
                      </div>
                    </div>
                    <div class="text-right">
                      <div class="flex text-gray-900 text-md mb-2">
                        <p>Shipping: MAERSK</p>
                      </div>
                      <div class="flex justify-items-end" v-if="container">
                        <basic-production-details
                          :container_id="container.id"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">#</th>
                  <th scope="col" class="table-header-cell">Fecha</th>
                  <th scope="col" class="table-header-cell">Cultivo</th>
                  <th scope="col" class="table-header-cell">Comprador</th>
                  <th scope="col" class="table-header-cell">Cosechado</th>
                  <th scope="col" class="table-header-cell">Descarte</th>
                  <th scope="col" class="table-header-cell">Procesado</th>
                  <th scope="col" class="table-header-cell"></th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="(harvested_batch, index_batch) in containers"
                  :key="harvested_batch.id"
                >
                  <td class="table-cell-pos">{{ index_batch + 1 }}</td>
                  <td class="table-cell">
                    {{ dateFormatter(harvested_batch.registered_at) }}
                  </td>
                  <td class="table-cell">{{ harvested_batch.crop.name }}</td>
                  <td class="table-cell">{{ harvested_batch.buyer_name }}</td>
                  <td class="table-cell">
                    {{ numberWithPrecision(harvested_batch.total_weight, 1) }}
                    kg
                  </td>
                  <td class="table-cell">
                    {{
                      numberWithPrecision(harvested_batch.discarded_weight, 1)
                    }}
                    kg
                  </td>
                  <td class="table-cell">
                    {{ numberWithPrecision(harvested_batch.ok_weight, 1) }} kg
                  </td>
                  <td class="table-cell-action">
                    <basic-production-details
                      :harvested_batch="harvested_batch"
                    />
                  </td>
                </tr>
              </tbody>
            </table> -->
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-6" v-show="this.option_tabs[1].current">
    <div class="sm:flex sm:items-center">
      <div class="sm:flex-auto">
        <h1 class="text-xl font-semibold text-gray-900">
          Gráfico de rendimiento
        </h1>
      </div>
    </div>
    <div class="mt-8">
      <div class="panel">
        <div class="panel-body flex flex-wrap">
          <!-- <div class="w-full md:w-1/2 lg:my-4 lg:px-4 lg:w-1/2">
            <basic-production-graphic
              v-if="graphic_data_loaded"
              :series_data_prop="graphic_series_data"
              :x_categories_prop="graphic_x_categories"
            />
          </div> -->
          <div class="w-full md:w-full lg:my-4 lg:px-4">
            <basic-production-stacked-size
              v-if="graphic_data_loaded"
              :series_data_prop="graphic_data_stacked_size"
              :x_categories_prop="graphic_x_stacked_size"
            />
          </div>
          <div class="w-full md:w-full lg:my-4 lg:px-4">
            <basic-production-tree-crop-exp-packages
              v-if="graphic_data_loaded"
              :series_data_prop="crop_size_data"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasicProductionRequester from "@/views/open_queries/requesters/customer/basic_production.js";
import BasicProductionDetails from "@/components/views/open_queries/customer/BasicProductionDetails.vue";
// import BasicProductionGraphic from "@/components/views/open_queries/customer/BasicProductionGraphic.vue";
import BasicProductionTreeCropExpPackages from "@/components/views/open_queries/customer/BasicProductionTreeCropExpPackages.vue";
import BasicProductionStackedSizeGraphic from "@/components/views/open_queries/customer/BasicProductionStackedSizeGraphic.vue";

let crop_size_data = [
  {
    data: [
      { x: "K06", y: 218 },
      { x: "K07", y: 149 },
      { x: "K08", y: 184 },
      { x: "K09", y: 55 },
      { x: "K10", y: 84 },
      { x: "K12", y: 31 },
      { x: "K14", y: 70 },
    ],
  },
];

export default {
  name: "OQProducerBasicProduction",
  components: {
    "basic-production-details": BasicProductionDetails,
    // "basic-production-graphic": BasicProductionGraphic,
    "basic-production-tree-crop-exp-packages":
      BasicProductionTreeCropExpPackages,
    "basic-production-stacked-size": BasicProductionStackedSizeGraphic,
  },
  props: ["customer_id", "crop_id"],
  data() {
    return {
      containers: [],
      graphic_series_data: [],
      graphic_x_categories: [],
      graphic_x_stacked_size: [],
      graphic_data_stacked_size: [],
      crop_size_data: crop_size_data,
      graphic_data_loaded: false,
      option_tabs: [
        { name: "Contenedores", icon: "fa-solid fa-seedling", current: true },
        {
          name: "Gráfico de rendimiento",
          icon: "fa-solid fa-chart-line",
          current: false,
        },
      ],
    };
  },
  methods: {
    switchTab: function (tabIdx) {
      for (let i = 0; i < this.option_tabs.length; i++)
        this.option_tabs[i].current = false;

      this.option_tabs[tabIdx].current = true;
    },
    fetchContainers: async function () {
      let response = await BasicProductionRequester.listProduction(
        this.customer_id,
        this.crop_id
      );
      this.containers = response.data;
      this.setDefaultGraphData();
      this.setStackedSizeGraphData();

      this.graphic_data_loaded = true;
    },
    setDefaultGraphData: function () {
      let data_total_exp_package = [];
      let data_x_categories = [];

      for (let i = 0; i < this.containers.length; i++) {
        data_total_exp_package.push(this.containers[i].total_exp_packages);
        data_x_categories.push(this.containers[i].container_code);
      }

      this.graphic_series_data[0] = {
        name: "Peso neto procesado",
        data: data_total_exp_package,
      };
      this.graphic_x_categories = data_x_categories;
    },
    setStackedSizeGraphData: function () {
      let data_total_by_size = [];
      let data_x = [];
      for (let i = 0; i < this.containers.length; i++) {
        let container = this.containers[i];
        data_x.push(container.container_code);
      }
      crop_size_data[0].data.forEach((size) => {
        let serie = { name: size.x, data: [] };
        data_x.forEach((x) => {
          x;
          let data = parseInt(Math.random() * size.y);
          serie.data.push(data);
        });
        data_total_by_size.push(serie);
      });
      this.graphic_x_stacked_size = data_x;
      this.graphic_data_stacked_size = data_total_by_size;
    },
    download_rep_xlsx: async function () {
      // try {
      //   let response = await BasicProductionRequester.downloadRepXlsx(
      //     this.customer_id,
      //     this.crop_id
      //   );
      //   const file = response.data;
      //   var fileURL = window.URL.createObjectURL(new Blob([file]));
      //   var fileLink = document.createElement("a");
      //   fileLink.href = fileURL;
      //   fileLink.setAttribute("download", "reporte_produccion.xlsx");
      //   document.body.appendChild(fileLink);
      //   fileLink.click();
      // } catch (error) {
      //   error;
      // }
    },
  },
  beforeMount() {
    this.checkIfAuthenticated();
    this.fetchContainers();
  },
};
</script>
